import { Directive, TemplateRef } from '@angular/core';

@Directive({
    selector: '[luiCarouselSlide]',
    standalone: false
})
export class CarouselSlideDirective {
  constructor(public template: TemplateRef<CarouselSlideDirective>) {}
}
